import { SensorEnum } from 'core/models/deviceModel';

export type SensorCode = '100' | '101' | '102' | '103' | '104' | '105' | '106';
export const sensorType = {
  '100': SensorEnum.ECG,
  '101': SensorEnum.SpO2,
  '102': SensorEnum.BP,
  '103': SensorEnum.Temperature,
  '104': SensorEnum.CGM,
  '105': SensorEnum.Watch,
  '106': SensorEnum.WeightScale,
};

// eslint-disable-next-line no-shadow
export enum NoiseSuppressionEnum {
  ALL = 'all',
  VALIDATE = 'validate',
  FLAGFP = 'flagFP',
}

export const sensorTypeSel = [
  {
    id: '6852845225f1e3adae8d7d2d',
    name: SensorEnum.ECG,
    code: '100',
  },
  {
    id: '6852845225f1e3adae8d7d2e',
    name: SensorEnum.SpO2,
    code: '101',
  },
  {
    id: '6852845225f1e3adae8d7d2f',
    name: SensorEnum.BP,
    code: '102',
  },
  {
    id: '6852845225f1e3adae8d7d30',
    name: SensorEnum.Temperature,
    code: '103',
  },
  {
    id: '6852845225f1e3adae8d7d36',
    name: SensorEnum.Watch,
    code: '105',
  },
  {
    id: '6852845225f1e3adae8d7d37',
    name: SensorEnum.WeightScale,
    code: '106',
  },
];

export const CGMSensorType = {
  id: '6852845225f1e3adae8d7d31',
  name: SensorEnum.CGM,
  code: '104',
};

export const languageMap: any = {
  zh: 'zh-CN',
  en: 'en-US',
};

export const questionaireMap: any = {
  Mobility: 'MO',
  'Self-Care': 'SC',
  'Usual Activities': 'UA',
  'Pain/Discomfort': 'PD',
  'Anxiety/Depression': 'AD',
};

export default { sensorType };
